import { render, staticRenderFns } from "./PlaceHolderLoader.vue?vue&type=template&id=351c9c1e&scoped=true"
import script from "./PlaceHolderLoader.vue?vue&type=script&lang=ts"
export * from "./PlaceHolderLoader.vue?vue&type=script&lang=ts"
import style0 from "./PlaceHolderLoader.vue?vue&type=style&index=0&id=351c9c1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351c9c1e",
  null
  
)

export default component.exports